<p *transloco="let t">
  <span (click)="debugApplication()"
        class="text-muted font-weight-light">{{ t('questionnaireVersion')}} {{version}} {{envShortcut}}</span>
</p>
